import { Injectable, signal } from "@angular/core";
import { delay, map, Observable, of } from "rxjs";

import { environment } from "@azm/environments/environment";

type Config = Record<string, unknown>;

@Injectable({
	providedIn: "root",
})
export class ConfigService {
	appConfig = signal<Config>({});

	initializeConfig(): Observable<boolean> {
		const snapshot = structuredClone(environment) as unknown as Config;
		this.appConfig.set(snapshot);
		return of(true).pipe(
			delay(100),
			map(() => true),
		);
	}
}
